import { render, staticRenderFns } from "./IntroModal.vue?vue&type=template&id=0e89b21a&scoped=true&"
import script from "./IntroModal.vue?vue&type=script&lang=js&"
export * from "./IntroModal.vue?vue&type=script&lang=js&"
import style0 from "./IntroModal.vue?vue&type=style&index=0&id=0e89b21a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e89b21a",
  null
  
)

export default component.exports